import React from 'react';

export const ApplyContext = React.createContext();
